import { getResourcesDate, RESOURCES_DATE_FORMAT } from "@utils/timeHelpers";
import { getCellText, getUserCellText, getUserHeaderTitle } from "@containers/Admin/containers/PendingDashboard/shared/SharedComponents";
import { formatUserStatus, getUserTooltipText } from "../UserPage/helpers";
import { isDesktop } from "@shared/constants/media-queries";
import format from 'date-fns/format';

/**
 * Generate table columns
 * @param {string} width - columns width
 * @param {boolean} showMentorColumn - check if current user can see mentor column
 * @param {boolean} showBusinessUnitColumn - check if current user can see business unit column
 * @returns {React.ReactElement} React element
 */
export const getTableColumn = (width, showMentorColumn, showBusinessUnitColumn = false) => {
  const userColumnWidth = showBusinessUnitColumn ? '1.2fr' : width;
  const standardColumnWidth = showBusinessUnitColumn ? '0.9fr' : width;

  return [
    {
      title: getUserHeaderTitle('User', { uppercaseLabel: false }),
      getDisplay: ({ fullName, birthdate, email }) => getUserCellText({ fullName, birthdate, email }),
      getTooltipText: ({ fullName, birthdate, email }) => getUserTooltipText({ fullName, birthdate, email }),
      width: userColumnWidth,
      sortable: true,
      sortField: "fullName",
    },
    ...(showMentorColumn ? [{
      title: "Mentor",
      getDisplay: ({ mentor }) => mentor && getCellText(mentor[0]?.fullName),
      width: standardColumnWidth,
      sortable: false,
      sortField: "mentor[0].fullName",
    }] : []),
    {
      title: "Course",
      getDisplay: ({ course }) =>  getCellText(course?.name),
      width: standardColumnWidth,
      sortable: false,
      sortField: "course.name",
    },
    {
      title: "Skill",
      getDisplay: ({ currentSkill }) => getCellText(currentSkill?.name),
      width: standardColumnWidth,
      sortable: false,
      sortField: "currentSkill.name",
    },
    {
      title: "Last practiced",
      getDisplay: ({ lastPracticed }) => lastPracticed && getCellText(format(new Date(lastPracticed), RESOURCES_DATE_FORMAT)),
      width: standardColumnWidth,
      sortable: false,
      sortField: "lastPracticed",
    },
    {
      title: "Status",
      getDisplay: ({ status }) => getCellText(formatUserStatus(status)),
      width: standardColumnWidth,
      sortable: false,
      sortField: "status",
    },
    ...(showBusinessUnitColumn ? [{
      title: 'Business Unit',
      getDisplay: ({ businessUnitsInfo }) => getCellText(businessUnitsInfo?.map((businessUnit) => businessUnit?.name).filter(Boolean).join(', ')),
      width: standardColumnWidth,
      sortable: false,
      sortField: 'businessUnitsInfo.name',
    }] : []),
  ];
}


export const userListOffset = isDesktop() ? 15 : 9;
